import { Component, OnInit, Input, EventEmitter, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { IstSummaryService } from 'src/app/services/ist/ist-summary.service';
import { currencyOptionsConstant, titleOptionsConstant, serviceConstants } from 'src/app/constants/service.constants';
import { Subject } from 'rxjs';
import { GridApi } from 'ag-grid-community';
import { IstStudyTeamOrganizationViewModalComponent } from '../../ist-study-team-organization/ist-study-team-organization-view-modal/ist-study-team-organization-view-modal.component';
import { EditAndDeleteOperationsRenderer } from 'src/app/common/client-grid/edit-and-delete-operations.component';
import { IstStudyTeamAddOrRoleComponent } from '../ist-study-team-add-or-role/ist-study-team-add-or-role.component';
import { IstDataShareService } from '../../../../services/ist/ist-datashare.service';
import { CommonService } from '../../../../services/common.service';
import { UserService } from '../../../../services/user.service';
import { ExtendedFormControlsComponent } from 'src/app/common/extended-form-controls/extended-form-controls.component';
import { Document_Upload_File } from '../../../../models/common';
import * as $ from 'jquery';
//import * as _ from 'lodash';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-ist-study-team-team-view-modal',
  templateUrl: './ist-study-team-team-view-modal.component.html',
  styleUrls: ['./ist-study-team-team-view-modal.component.scss']
})
export class IstStudyTeamTeamViewModalComponent implements OnInit {

  formFields: any;
  titleOptions: any = [];
  columnDefs: any;
  operations: any;
  gridApi: GridApi;
  selectedRow: any;
  rowData: any;
  gridOptions: any;
  studyTeamTeamForm: UntypedFormGroup
  loadTeam = false;
  content: any;
  heading: string;
  action: Subject<any> = new Subject();
  formData: FormData;
  files: any[];
  uploadInput: EventEmitter<any>;
  humanizeBytes: Function;
  dragOver: boolean;
  currencyOptions = currencyOptionsConstant;
  frameworkComponents;
  context;
  ApplicationID: any;
  FilesList: any = [];
  Listfiles:any=[];
  userType: string = "";
  documaent_attach_list: Document_Upload_File[] = [];
  IsMultipermission: string = "yes";
  IsClicked = false;
  RolesList: any = [];
  @ViewChild('extended') extendedForm: ExtendedFormControlsComponent;
  AttachementIds: string = "";
  permission: string = "";
  IsAdmin: string = "";
  @Input() public Content: any;
  staticformFields: any;

  constructor(
    private summaryService: IstSummaryService,
    public modalRef: NgbActiveModal,
    private modalService: NgbModal,
    private istDatashareserivse: IstDataShareService,
    public commonService: CommonService,
    private userService: UserService,
  ) {

  }

  getStaticFiledsData(screenCode: string) {
    this.commonService.getScreenStaticFields(screenCode)
      .subscribe(summary => {
        this.staticformFields = summary["Data"];
      });
  }

  onGridReady(params) {
    this.gridApi = params.api;
    setTimeout(() => {
      this.gridApi.sizeColumnsToFit();
      this.gridApi.startEditingCell(params);
    }, 500);
  }

  ngOnInit() {
    this.getStaticFiledsData('SCR-002');
    this.permission = "";

    if (this.commonService.getPagePermission("IST02") != null && this.commonService.getPagePermission("IST02") != undefined) {
      this.permission = this.commonService.getPagePermission("IST02").toLowerCase();
    }

    this.columnDefs = [
      {
        "headerName": "Organization",
        "field": "MemberOrganizationName",
        "sort": "asc",
      },
      {
        "headerName": "User Role",
        "field": "RoleName",
      }
    ]

    this.rowData = [];
    this.gridOptions = {
      pagination: true,
      rowSelection: 'single',
      rowHeight: 32,
      defaultColDef: {
        sortable: true,
        suppressNavigable: true,
        cellClass: 'no-border',
        suppressMovable: true,
        IsRequiredEdit: true
      }
    }

    this.context = { componentParent: this };
    this.frameworkComponents = {
      deleteRenderer: EditAndDeleteOperationsRenderer
    };

    this.files = [];
   // this.Listfiles = _.cloneDeep(this.Content.content.docList);
    this.userType = this.userService.getUserType();
    this.istDatashareserivse.ApplicationID.subscribe(x => { this.ApplicationID = x; });

    this.studyTeamTeamForm = new UntypedFormGroup({
      ID: new UntypedFormControl(""),
      APPLICATION_ID: new UntypedFormControl(""),
      TITLE: new UntypedFormControl(""),
      FIRST_NAME: new UntypedFormControl(""),
      MIDDLE_NAME: new UntypedFormControl(""),
      LAST_NAME: new UntypedFormControl(""),
      OCCUPATION: new UntypedFormControl(""),
      SPECIALIZATION: new UntypedFormControl(""),
      LICENSE_NO: new UntypedFormControl(""),
      ADDRESS: new UntypedFormControl(""),
      EMAIL: new UntypedFormControl("", [Validators.email]),
      PHONE: new UntypedFormControl("", [Validators.pattern("^[0-9]*$"),
      Validators.maxLength(20)])
    });

    setTimeout(() => {
      this.loadTeam = true;
    }, 350);

    if (this.Content.heading == "Edit" || this.Content.heading == "View") {
      this.getStudyTeamData();
      this.GetGridData();
    }

    if (this.Content.heading === 'Add') { //Add mode
      this.Content.content.id = this.commonService.getUniqueId();
    }
    this.setMasterData();
  }

  setMasterData() {
    this.summaryService.masterData("api/ISTStudyTeam/GetMasterData?ApplicationID=" + this.ApplicationID + "&RecordID=" + this.Content.content.id).subscribe(summary => {
      if (summary["MasterData3"] != null && summary["MasterData3"] != undefined) {
        this.IsMultipermission = summary["MasterData3"][0].value;
      }
      if (summary["MasterData4"] != null && summary["MasterData4"] != undefined) {
        this.titleOptions = summary["MasterData4"];
        this.titleOptions = [{ label: "Select", value: "", checked: true }].concat(this.titleOptions);
      }
    });
  }

  GetGridData() {
    this.summaryService.getScreenDataForEdit("api/ISTStudyTeam/GridDataEdit?RecordID1="
      + this.Content.content.id + "&ApplicationID1=" + this.ApplicationID)
      .subscribe(result => {

      this.loadTeam = false;
      this.rowData = this.setOperations(result);
      setTimeout(() => {
        this.loadTeam = true;
      }, 200);
    });
  }

  getStudyTeamData() {
    this.summaryService.getScreenDataForEdit(
      "api/ISTStudyTeam/Edit?RecordID=" + this.Content.content.id
      + "&ApplicationID=" + this.ApplicationID)
      .subscribe(result => {
      if (result != null) {
        this.FilesList = result["FilesList"];
        this.Listfiles =  result["FilesList"];
        this.studyTeamTeamForm.patchValue({
          ID: result["Modal"]["ID"],
          APPLICATION_ID: result["Modal"]["APPLICATION_ID"],
          TITLE: result["Modal"]["TITLE"],
          FIRST_NAME: result["Modal"]["FIRST_NAME"],
          MIDDLE_NAME: result["Modal"]["MIDDLE_NAME"],
          LAST_NAME: result["Modal"]["LAST_NAME"],
          OCCUPATION: result["Modal"]["OCCUPATION"],
          SPECIALIZATION: result["Modal"]["SPECIALIZATION"],
          LICENSE_NO: result["Modal"]["LICENSE_NO"],
          ADDRESS: result["Modal"]["ADDRESS"],
          EMAIL: result["Modal"]["EMAIL"],
          PHONE: result["Modal"]["PHONE"]
        });
        this.IsAdmin = result["Modal"]["CREATED_BY"];
        this.extendedForm.rowid = result["Modal"]["ID"];
        this.extendedForm.getResponse();
      }

      if (this.Content.heading == "View") {
        this.studyTeamTeamForm.disable();

      }
      else {
        if (this.IsAdmin == "Admin") {
          this.studyTeamTeamForm.controls["TITLE"].disable();
          this.studyTeamTeamForm.controls["FIRST_NAME"].disable();
          this.studyTeamTeamForm.controls["MIDDLE_NAME"].disable();
          this.studyTeamTeamForm.controls["LAST_NAME"].disable();
          this.studyTeamTeamForm.controls["LICENSE_NO"].disable();
          this.studyTeamTeamForm.controls["OCCUPATION"].disable();
          this.studyTeamTeamForm.controls["SPECIALIZATION"].disable();
          this.studyTeamTeamForm.controls["ADDRESS"].disable();
          this.studyTeamTeamForm.controls["PHONE"].disable();
          this.studyTeamTeamForm.controls["EMAIL"].disable();
        }
      }
    });
  }

  addRow() {
    let modalRef = this.modalService.open(IstStudyTeamAddOrRoleComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-sm right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content = {
      heading: 'Add',
      content: {
        id: this.studyTeamTeamForm.controls["ID"].value,
        ApplicationID: this.ApplicationID,
        rowDataRoles: this.rowData,
        staticformFields:this.staticformFields
      }
    }
    modalRef.result.then(result => {
      this.loadTeam = false;
      this.rowData.push(result);
      this.rowData = this.setOperations(this.rowData);
      setTimeout(() => {
        this.loadTeam = true;
      }, 100);
    });
  }

  DownloadFile(ID) {
    var fileID = ID;
    let Url = serviceConstants.apiURL + "api/ISTFileAttachments/Downloadfile?FileID=" + fileID;
    window.open(Url);
  }

  ViewFile(fileID, fileName) {
    this.commonService.previewFile(fileID, fileName, "med");
  }

  onRowDoubleClicked(event) { }

  ClosePopup() {
    this.modalRef.close();
  }

  SaveStudyTeam() {
    if (this.IsClicked == false) {

      if (this.validateControls()) {
        this.IsClicked = true;
        var formData = this.studyTeamTeamForm.value;
        formData.APPLICATION_ID = this.ApplicationID;
        formData.TITLE = this.studyTeamTeamForm.controls["TITLE"].value;
        formData.FIRST_NAME = this.studyTeamTeamForm.controls["FIRST_NAME"].value;
        formData.MIDDLE_NAME = this.studyTeamTeamForm.controls["MIDDLE_NAME"].value;
        formData.LAST_NAME = this.studyTeamTeamForm.controls["LAST_NAME"].value;
        formData.OCCUPATION = this.studyTeamTeamForm.controls["OCCUPATION"].value;
        formData.SPECIALIZATION = this.studyTeamTeamForm.controls["SPECIALIZATION"].value;
        formData.LICENSE_NO = this.studyTeamTeamForm.controls["LICENSE_NO"].value;
        formData.ADDRESS = this.studyTeamTeamForm.controls["ADDRESS"].value;
        formData.EMAIL = this.studyTeamTeamForm.controls["EMAIL"].value;
        formData.PHONE = this.studyTeamTeamForm.controls["PHONE"].value;
        if (!this.staticformFields.StudyTeam_Upload.IS_MULTISELECT){
          formData.Attachments =  this.Listfiles;
        }
       
        this.RolesList = [];
        if (this.rowData != null && this.rowData.length > 0) {
          for (let j = 0; j < this.rowData.length; j++) {
            let obj = {
              "MemberOrganizationId": this.rowData[j].MemberOrganizationId, "MemberOrganizationName": this.rowData[j].MemberOrganizationName,
              "RoleId": this.rowData[j].RoleId, "RoleName": this.rowData[j].RoleName
            };
            this.RolesList.push(obj);
          }
        }
        formData.MemberOrganizationsList = this.RolesList;

        let formData1 = new FormData();
        if (this.documaent_attach_list != null && this.documaent_attach_list.length > 0) {
          for (let i = 0; i < this.documaent_attach_list.length; i++) {
            this.documaent_attach_list[i].TRANSACTION_ID = ("" + (i + 1));
            formData1.append(("" + (i + 1)), this.documaent_attach_list[i].File);
          }
        }
        

        if (this.Content.heading == "Add") {
          formData["ID"] = this.Content.content.id;
          formData1.append("ScreenData", JSON.stringify(formData));
          this.summaryService.FilesInsert("api/ISTStudyTeam/Insert", formData1).subscribe(result => {
            if (result.Status === 0) {
              this.extendedForm.saveControls(result.TransactionID, this.ApplicationID, result.TransactionCode).subscribe(result1 => {
                if (result1.Status === 0) {
                  this.commonService.SuccessBanner(result.Message);

                  this.modalRef.close();
                  this.Content.heading = "Edit";
                  this.IsClicked = false;
                  this.studyTeamTeamForm.controls["ID"].setValue(this.Content.content.id);
                }
                else {
                  this.commonService.ValidationBanner(result1.Message);
                }

              });
            }
            else {
              this.commonService.ValidationBanner(result.Message);
            }
          });
        }
        else {
          this.summaryService.getAppSubmitValidations(
            "api/ISTStudyTeam/IST_APPInActiveSTValidation?ApplicationID="
            + this.ApplicationID + "&TitleId=" + formData["TITLE"]
            + "&PkId=" + formData["ID"])
            .subscribe((resultInactive) => {
            if (resultInactive != null && resultInactive != undefined) {
              if (resultInactive.Status == 0) {
                let dataMsg = resultInactive.Data.Validations[0].FiledsData.join("</br>");
                this.commonService.ValidationBanner(dataMsg);
              }
              else {
                formData1.append("ScreenData", JSON.stringify(formData));
               formData1.append("SavedAttachements", this.AttachementIds);
               formData1.append("DeletedFiles",  this.Listfiles);
               //formData1.append("filesList",);
                this.summaryService.FilesInsert("api/ISTStudyTeam/Update", formData1).subscribe(result => {
                  if (result.Status === 0 || result.ErrorCode === "NOCHANGES") {
                    this.extendedForm.saveControls(result.TransactionID, this.ApplicationID, result.TransactionCode)
                      .subscribe(result1 => {
                      if (result1.ErrorCode === "NOCONTROLS") {
                        if (result.Status === 0)
                        {
                          this.commonService.SuccessBanner(result.Message);
                          this.modalRef.close();
                        }
                        else {
                          this.commonService.ValidationBanner(result.Message);
                        }
                        this.IsClicked = false;
                      }
                      else {
                        if (result.ErrorCode === "NOCHANGES" && result1.ErrorCode === "NOCHANGES") {
                          this.commonService.ValidationBanner(result.Message);
                        }
                        else {

                          this.modalRef.close();
                          let mname = formData["MIDDLE_NAME"] != null ? formData["MIDDLE_NAME"] : "";
                          this.commonService.SuccessBanner(formData["FIRST_NAME"] + " " + mname + " " + formData["LAST_NAME"] + " Details updated successfully");
                        }

                        this.Content.heading = "Edit";
                        this.IsClicked = false;
                      }
                    });
                  }
                  else {
                    this.commonService.ValidationBanner(result.Message);
                  }
                });
              }
            }
          });
        }
      }
    }
  }

//   uploadchange(event): void {
//     let Flag = true;
//     let DupFlag = false;
//     let DOCUMENT_NAME="";
//     if (this.documaent_attach_list == undefined || this.documaent_attach_list == null) {
//       this.documaent_attach_list = [];
//     }

//     for (let i = 0; i < event.target.files.length; i++) {
//       let uploadFile = new Document_Upload_File();
//       var file = event.target.files[i].name;
//       var ext = file.match(/\.([^\.]+)$/)[1];
//       var filesize = event.target.files[i].size;

//       if (file != null && ((filesize > 15728640) || (ext != 'docx' && ext != 'doc' && ext != 'ppt' && ext != 'pptx' && ext != 'xls' && ext != 'xlsx' && ext != 'txt' && ext != 'pdf'))) {
//         Flag = false;
//         //this.commonService.ValidationBanner("Please upload files with Word, PPT, Excel, Pdf, Text formats only with maximum size of 15MB");
//       }
//       else {
//         let hasValue;
//         uploadFile.ID = this.commonService.getUniqueId();
//         uploadFile.DOCUMENT_NAME = event.target.files[i].name;
//         uploadFile.File = event.target.files[i];
//         uploadFile.Status = "Add";
//         if (this.FilesList && this.FilesList.length > 0) {
//           hasValue = this.FilesList.filter(x => x.FileName.toLowerCase() == uploadFile.DOCUMENT_NAME.toLowerCase());
//         } else {
//           hasValue = this.documaent_attach_list.filter(x => x.DOCUMENT_NAME.toLowerCase() == uploadFile.DOCUMENT_NAME.toLowerCase() && x.Status != "Delete");
//         }
//         if (hasValue.length > 0) {
//           DupFlag=true;
//           if(DOCUMENT_NAME!="")
//           DOCUMENT_NAME+= ","+uploadFile.DOCUMENT_NAME;
//         else 
//         DOCUMENT_NAME=uploadFile.DOCUMENT_NAME;
//         } else {
//           this.documaent_attach_list.push(uploadFile);
//         }
//       }
//     }
// if(DupFlag)
// this.commonService.ValidationBanner("File already exists with " + DOCUMENT_NAME + " Please update the unique file name");
//     if (!Flag)
//       this.commonService.ValidationBanner("Please upload files with Word, PPT, Excel, Pdf, Text formats only with maximum size of 15MB");
//   }

  uploadchange(event): void {
    if (this.documaent_attach_list == undefined || this.documaent_attach_list== null) {
      this.documaent_attach_list= [];
    }
    let hasUnFormat = false;
    let hasMultipleFiles = false;
    let Duplicate_File_List = [];
    
    for (let i = 0; i < event.target.files.length; i++) {
      let uploadFile = new Document_Upload_File();
      var file = event.target.files[i].name;   
      var ext = file.match(/\.([^\.]+)$/)[1];
      var filesize = event.target.files[i].size;

      if (file != null && ((filesize > 15728640) || (ext !='docx' && ext != 'doc' && ext != 'ppt' && ext != 'pptx' && ext != 'xls' && ext != 'xlsx' && ext != 'txt' && ext != 'pdf' ))) 
      {
        hasUnFormat = true;
      }
      else 
      {
        let hasValue;
        let value;
        uploadFile.ID = this.commonService.getUniqueId();
        uploadFile.DOCUMENT_NAME = event.target.files[i].name;
        uploadFile.File = event.target.files[i];
        uploadFile.Status = "Add";
        if(this.FilesList?.length > 0){
          hasValue = this.FilesList?.filter(x=> x.FileName.toLowerCase() == uploadFile.DOCUMENT_NAME.toLowerCase());
        } 
        
        if(this.documaent_attach_list?.length > 0)
        {
          value = this.documaent_attach_list.filter(x=> x.DOCUMENT_NAME.toLowerCase() == uploadFile.DOCUMENT_NAME.toLowerCase());

        }

        if(hasValue?.length > 0 || value?.length > 0)
        {
          hasMultipleFiles = true;
          Duplicate_File_List.push(uploadFile.DOCUMENT_NAME);
        } 
        
          else if (this.staticformFields.StudyTeam_Upload.IS_MULTISELECT){
            this.documaent_attach_list.push(uploadFile);
            } 
            else if(this.FilesList.length>0){
                this.documaent_attach_list =[];
               this.FilesList=[];
                this.documaent_attach_list.push(uploadFile);
              }
              else{
                this.documaent_attach_list.push(uploadFile);
              }
              
             
            
        
      }
    }

    if(hasUnFormat){
      this.commonService.ValidationBanner("Please upload files with Word, PPT, Excel, Pdf, Text formats only with maximum size of 15MB"); 
    }

    if(hasMultipleFiles){
      this.commonService.ValidationBanner("File already exists with " + Duplicate_File_List.join(', ') + ". Please update the unique file name");
    }
  }
  DeleteUpload(file): void {
    if (file.Status == "Add") {
      let code = file.ID;
      this.documaent_attach_list = this.documaent_attach_list.filter(function (sec) {
        return sec.ID != code;
      }, code);
    }
    else {
      file.Status = "Delete";
    }
  }

  DeleteSavedUpload(item): void {
    let code = item;

    this.FilesList.forEach(sec => {
      if (sec.ID === code) {
        if (this.AttachementIds != null && this.AttachementIds != "" && this.AttachementIds != null)
          this.AttachementIds += "," + sec.ID + ",";
        else
          this.AttachementIds = sec.ID;
        let isExist = this.FilesList.findIndex((r: any) => r.ID === code);
        if (isExist != -1) {
          this.FilesList.splice(isExist, 1);
        }
      }
    });
  }

  SaveUploadAttachment(id): void {
    ;

    let Url = serviceConstants.apiURL + "api/ISTStudyTeam/UploadFiles?TransactionID=" + id;
    const event: any = {
      type: 'uploadAll',
      url: Url,
      method: 'POST',
      data: { Id: "" },
    };

    this.uploadInput.emit(event);
    this.files = [];
  }

  addNewOrg() {

    let modalRef = this.modalService.open(IstStudyTeamOrganizationViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-vlg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content = {
      heading: 'Add',
      content: {
        id: '',
        ApplicationID: this.ApplicationID
      }
    }
  }

  keyPress(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
      event.value = '';
    }
  }

  validateControls(): boolean {
    let isValid = true;
    let message = "";
    if (this.IsAdmin != "Admin") {
      const formData = this.studyTeamTeamForm.value;

      if (this.staticformFields?.TITLE.IS_Display && this.staticformFields?.TITLE.IS_MANDATORY) {
        if (formData.TITLE === null || formData.TITLE === "") {
          $("#TITLE").addClass("ng-touched ng-invalid validate-error");
          $("#TITLE").removeClass("ng-untouched ng-valid");
          message += `Please select ${this.staticformFields?.TITLE.LABEL_NAME} <br/>`;
          isValid = false;
        } else {
          $("#TITLE").addClass("ng-untouched ng-valid");
          $("#TITLE").removeClass("ng-touched ng-invalid validate-error");
        }
      }

      if (this.staticformFields?.FIRST_NAME.IS_Display && this.staticformFields?.FIRST_NAME.IS_MANDATORY) {
        if (formData.FIRST_NAME === null || formData.FIRST_NAME === "") {
          $("#FIRST_NAME").addClass("ng-touched ng-invalid validate-error");
          $("#FIRST_NAME").removeClass("ng-untouched ng-valid");
          message += `Please enter ${this.staticformFields?.FIRST_NAME.LABEL_NAME} <br/>`;
          isValid = false;
        } else {
          $("#FIRST_NAME").addClass("ng-untouched ng-valid");
          $("#FIRST_NAME").removeClass("ng-touched ng-invalid validate-error");
        }
      }

      if (this.staticformFields?.MIDDLE_NAME.IS_Display && this.staticformFields?.MIDDLE_NAME.IS_MANDATORY) {
        if (formData.MIDDLE_NAME === null || formData.MIDDLE_NAME === "") {
          $("#MIDDLE_NAME").addClass("ng-touched ng-invalid validate-error");
          $("#MIDDLE_NAME").removeClass("ng-untouched ng-valid");
          message += `Please enter ${this.staticformFields?.MIDDLE_NAME.LABEL_NAME} <br/>`;
          isValid = false;
        } else {
          $("#MIDDLE_NAME").addClass("ng-untouched ng-valid");
          $("#MIDDLE_NAME").removeClass("ng-touched ng-invalid validate-error");
        }
      }

      if (this.staticformFields?.LAST_NAME.IS_Display && this.staticformFields?.LAST_NAME.IS_MANDATORY) {
        if (formData.LAST_NAME === null || formData.LAST_NAME === "") {
          $("#LAST_NAME").addClass("ng-touched ng-invalid validate-error");
          $("#LAST_NAME").removeClass("ng-untouched ng-valid");
          message += `Please enter ${this.staticformFields?.LAST_NAME.LABEL_NAME} <br/>`;
          isValid = false;
        } else {
          $("#LAST_NAME").addClass("ng-untouched ng-valid");
          $("#LAST_NAME").removeClass("ng-touched ng-invalid validate-error");
        }
      }

      if (this.staticformFields?.LICENSE_NO.IS_Display && this.staticformFields?.LICENSE_NO.IS_MANDATORY) {
        if (formData.LICENSE_NO === null || formData.LICENSE_NO === "") {
          $("#LICENSE_NO").addClass("ng-touched ng-invalid validate-error");
          $("#LICENSE_NO").removeClass("ng-untouched ng-valid");
          message += `Please enter ${this.staticformFields?.LICENSE_NO.LABEL_NAME} <br/>`;
          isValid = false;
        } else {
          $("#LICENSE_NO").addClass("ng-untouched ng-valid");
          $("#LICENSE_NO").removeClass("ng-touched ng-invalid validate-error");
        }
      }

      if (this.staticformFields?.OCCUPATION.IS_Display && this.staticformFields?.OCCUPATION.IS_MANDATORY) {
        if (formData.OCCUPATION === null || formData.OCCUPATION === "") {
          $("#OCCUPATION").addClass("ng-touched ng-invalid validate-error");
          $("#OCCUPATION").removeClass("ng-untouched ng-valid");
          message += `Please enter ${this.staticformFields?.OCCUPATION.LABEL_NAME} <br/>`;
          isValid = false;
        } else {
          $("#OCCUPATION").addClass("ng-untouched ng-valid");
          $("#OCCUPATION").removeClass("ng-touched ng-invalid validate-error");
        }
      }

      if (this.staticformFields?.SPECIALIZATION.IS_Display && this.staticformFields?.SPECIALIZATION.IS_MANDATORY) {
        if (formData.SPECIALIZATION === null || formData.SPECIALIZATION === "") {
          $("#SPECIALIZATION").addClass("ng-touched ng-invalid validate-error");
          $("#SPECIALIZATION").removeClass("ng-untouched ng-valid");
          message += `Please enter ${this.staticformFields?.SPECIALIZATION.LABEL_NAME} <br/>`;
          isValid = false;
        } else {
          $("#SPECIALIZATION").addClass("ng-untouched ng-valid");
          $("#SPECIALIZATION").removeClass("ng-touched ng-invalid validate-error");
        }
      }

      if (this.staticformFields?.ADDRESS.IS_Display && this.staticformFields?.ADDRESS.IS_MANDATORY) {
        if (formData.ADDRESS === null || formData.ADDRESS === "") {
          $("#ADDRESS").addClass("ng-touched ng-invalid validate-error");
          $("#ADDRESS").removeClass("ng-untouched ng-valid");
          message += `Please enter ${this.staticformFields?.ADDRESS.LABEL_NAME} <br/>`;
          isValid = false;
        } else {
          $("#ADDRESS").addClass("ng-untouched ng-valid");
          $("#ADDRESS").removeClass("ng-touched ng-invalid validate-error");
        }
      }

      if (this.staticformFields?.PHONE.IS_Display && this.staticformFields?.PHONE.IS_MANDATORY) {
        if (formData.PHONE === null || formData.PHONE === "") {
          $("#PHONE").addClass("ng-touched ng-invalid validate-error");
          $("#PHONE").removeClass("ng-untouched ng-valid");
          message += `Please enter ${this.staticformFields?.PHONE.LABEL_NAME} <br/>`;
          isValid = false;
        } else {
          $("#PHONE").addClass("ng-untouched ng-valid");
          $("#PHONE").removeClass("ng-touched ng-invalid validate-error");
        }
      }

      if (this.staticformFields?.EMAIL.IS_Display && this.staticformFields?.EMAIL.IS_MANDATORY) {
        if (formData.EMAIL === null || formData.EMAIL === "" || formData.EMAIL === undefined) {
          $("#EMAIL").addClass("ng-touched ng-invalid validate-error");
          $("#EMAIL").removeClass("ng-untouched ng-valid");
          message += `Please enter ${this.staticformFields?.EMAIL.LABEL_NAME} <br/>`;
          isValid = false;
        } else {
          if (this.commonService.validateEmail(formData.EMAIL)) {
            $("#EMAIL").addClass("ng-untouched ng-valid");
            $("#EMAIL").removeClass("ng-touched ng-invalid validate-error");
          }
          else {
            $("#EMAIL").addClass("ng-touched ng-invalid validate-error");
            $("#EMAIL").removeClass("ng-untouched ng-valid");
            message += `Please enter valid ${this.staticformFields?.EMAIL.LABEL_NAME} <br/>`;
            isValid = false;
          }
        }
      }

      if (this.staticformFields?.StudyTeam_Upload.IS_MANDATORY && this.staticformFields?.StudyTeam_Upload.IS_Display){
        if (this.documaent_attach_list == null || this.documaent_attach_list.length == 0 && this.FilesList.length == 0) {
          isValid = false;
          message += `Please upload ${this.staticformFields?.StudyTeam_Upload.LABEL_NAME} <br/>`;
        }
      }
    }

    if (this.rowData.length === 0) {
      message += "Please add at least one Role<br/>";
      isValid = false;
    }

    let ExtenMsgs = this.extendedForm.validateControlsMsgs();
    if (ExtenMsgs != null && ExtenMsgs != undefined && ExtenMsgs.length > 0) {
      isValid = false;
      message = message + ExtenMsgs; // this.extendedForm.validateControlsMsgs();
    }
    if (!isValid) {
      this.commonService.ValidationBanner(message);
      this.IsClicked = false
    }
    return isValid;
  }

  edit() {
    let MemOrgId = this['self'].selectedRow['MemberOrganizationId'];
    let RoleId = this['self'].selectedRow['RoleId'];
    let MemOrgName = this['self'].selectedRow['MemberOrganizationName'];
    let RoleName = this['self'].selectedRow['RoleName'];
    let modalRef = this['self'].modalService.open(IstStudyTeamAddOrRoleComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-sm right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content = {
      heading: 'Edit',
      content: {
        id: this['self'].studyTeamTeamForm.controls["ID"].value, ApplicationID: this.ApplicationID,
        MemberOrganizationId: MemOrgId, RoleId: RoleId,
        OrganizationName: MemOrgName,
        RoleName: RoleName,
        rowDataRoles: this['self'].rowData
      }
    }

    modalRef.result.then(result => {
      this['self'].loadTeam = false;
      let isOrgExist = this['self'].rowData.findIndex((Role: any) => Role.MemberOrganizationId == result.MemberOrganizationId);
      if (isOrgExist != -1) {
        this['self'].rowData.splice(isOrgExist, 1);
      }
      this['self'].rowData.push(result);
      this['self'].rowData = this['self'].setOperations(this['self'].rowData);
      setTimeout(() => {
        this['self'].loadTeam = true;
      }, 100);
    })

  }

  delete() {
    let MemOrgId = this['self'].selectedRow['MemberOrganizationId'];
    let isOrgExist = this['self'].rowData.findIndex((Role: any) => Role.MemberOrganizationId == MemOrgId);
    if (isOrgExist != -1) {
      this['self'].rowData.splice(isOrgExist, 1);
    }
    this['self'].rowData = this['self'].setOperations(this['self'].rowData);
    this['self'].loadTeam = false;
    setTimeout(() => {
      this['self'].loadTeam = true;
    }, 200);
  }

  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
  }
  onCallbackOperation(opr) {
    opr.callback(this.summaryService, this.istDatashareserivse);
  }

  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }

  setDef(parmoperations: any): any {
    this.operations = parmoperations.map(operation => {
      return (operation && (operation.id === 'add' || operation.id === 'view_modal')) ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
    });
    return this.operations;
  }

  setOperations(RawData: any): any {
    let tempoperations = [
      {
        "name": "Edit",
        "id": "edit"
      },
      {
        "name": "Delete",
        "id": "delete"
      }
    ];

    let tempoperations2 = [];

    RawData.forEach(element => {
      if (this.permission == "view" || this.Content.heading == 'View') {

        element["Operations"] = this.setDef(tempoperations2);
      }
      else {

        element["Operations"] = this.setDef(tempoperations);
      }
    });
    return RawData;
  }

  addOrganization() { }

  showFiles() {
    ;
    let files = '';
    if (this.files && this.files.length > 0) {
      for (let i = 0; i < this.files.length; i++) {
        files += this.files[i].name;
        if (!(this.files.length - 1 === i)) {
          files += ',';
        }
      }
    }
    return files;
  }

  startUpload(): void {
    const event: any = {
      type: 'uploadAll',
      url: 'your-path-to-backend-endpoint',
      method: 'POST',
      data: { foo: 'bar' },
    };
    this.files = [];
    this.uploadInput.emit(event);
  }

  cancelUpload(id: string): void {
    this.uploadInput.emit({ type: 'cancel', id: id });
  }

  onUploadOutput(output: any | any): void {
    ;
    if (output.type === 'allAddedToQueue') {
    } else if (output.type === 'addedToQueue') {
      ;
      if (this.files == undefined || this.files == null) {
        this.files = [];
      }
      this.files.push(output.file); // add file to array when added
    } else if (output.type === 'uploading') {
      // update current data in files array for uploading file
      const index = this.files.findIndex(file => file.id === output.file.id);
      this.files[index] = output.file;
    } else if (output.type === 'removed') {
      // remove file from array when removed
      this.files = this.files.filter((file: any) => file !== output.file);
    } else if (output.type === 'dragOver') {
      this.dragOver = true;
    } else if (output.type === 'dragOut') {
    } else if (output.type === 'drop') {
      this.dragOver = false;
    }
    this.showFiles();
  }
}
